import { ListProductsByFilterRequest } from '@clients/aggrego-proxy'
import { Product } from '@domain/model/Product'
import { ProductRepository } from '@infrastructure/repositories/product-repository'

export class GetCompleteHierarchyForDownloadUseCase {
  constructor(private readonly repository: ProductRepository) {}

  public execute(criteria: ListProductsByFilterRequest): Promise<Product[]> {
    return this.repository.getComplete(criteria)
  }
}
